import {
  Calculation,
  ChosenItemTransfer,
  CurrencyExchangeDetails,
  TransferFeesObj,
} from 'models/exchange-transfer-calculate'
import { SettingsKeys } from 'models/settings'

export * from '../config'

export const SETTINGS_KEYS: SettingsKeys[] = ['currency', 'currencies-not-supported', 'bank-transfer-countries']

export const DEFAULT_EXCHANGE_DATA: CurrencyExchangeDetails = {
  baseAmount: '100',
  baseCurrency: 'EUR',
  counterAmount: '422,59',
  direction: 'forward',
  counterCurrency: 'PLN',
}

export const DEFAULT_EXCHANGE_CALCULATION: Calculation = {
  sold_amount: '0',
  sold_currency: 'EUR',
  average_rate: '0',
  exchange_amount: '0',
  transfer_type: 'SEPA',
  transfer_type_fee: '0',
  bought_amount: '0',
  bought_currency: 'PLN',
  minimal_amount: '0',
  fee_amount: '0',
  fee_percent: '0',
  base_currency: 'EUR',
  fee: '0',
}

export const DEFAULT_TRANSFER_FROM_COUNTRY = 'PL'
export const DEFAULT_TRANSFER_TO_COUNTRY = 'PL'

export const DEFAULT_TRANSFER_FEES: TransferFeesObj[] = [
  {
    transfer_type: 'SEPA',
    currency: 'EUR',
    fee: '0.00 PLN',
    duration: {
      value: 1,
      unit: 'days',
    },
    fee_original: '0.00 PLN',
  },
  {
    transfer_type: 'TODAY',
    currency: 'EUR',
    fee: '20.00 PLN',
    duration: {
      value: 1,
      unit: 'days',
    },
    fee_original: '20.00 PLN',
  },
  {
    transfer_type: 'SEPA_INSTANT',
    currency: 'EUR',
    fee: '30.00 PLN',
    duration: {
      value: 1,
      unit: 'minutes',
    },
    fee_original: '30.00 PLN',
  },
]

export const DEFAULT_CHOSEN_ITEM_TRANSFER: ChosenItemTransfer = {
  chosenItemTransferType: DEFAULT_TRANSFER_FEES[0].transfer_type,
  chosenItemTransferFee: DEFAULT_TRANSFER_FEES[0].fee,
}
